var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewUnbilledAmountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.933594,
    y: 0.628906,
    width: 69.5197,
    height: 69.5197,
    rx: 5,
    fill: "#FFEFEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8341 21H27.8334C26.2686 21 25 22.2686 25 23.8334V44.7498C25 46.8562 27.2166 48.2261 29.1006 47.2841L29.3997 47.1346C30.1974 46.7357 31.1364 46.7357 31.934 47.1346L35.0666 48.7009C35.8643 49.0997 36.8032 49.0997 37.6009 48.7009L40.7335 47.1346C41.5312 46.7357 42.4701 46.7357 43.2678 47.1346L43.567 47.2841C45.4509 48.2261 47.6676 46.8562 47.6676 44.7498V23.8334C47.6676 22.2686 46.399 21 44.8341 21Z",
    fill: "#FDDDDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6669 26.6669H42.0007M30.6669 32.3338H42.0007M30.6669 38.0007H42.0007M27.8334 21H44.8341C46.399 21 47.6676 22.2686 47.6676 23.8334V44.7498C47.6676 46.8562 45.4509 48.2261 43.567 47.2841L43.2678 47.1346C42.4701 46.7357 41.5312 46.7357 40.7335 47.1346L37.6009 48.7009C36.8032 49.0997 35.8643 49.0997 35.0666 48.7009L31.934 47.1346C31.1364 46.7357 30.1974 46.7357 29.3997 47.1346L29.1006 47.2841C27.2166 48.2261 25 46.8562 25 44.7498V23.8334C25 22.2686 26.2686 21 27.8334 21Z",
    stroke: "#E33B32",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUnbilledAmountIcon);
export default __webpack_public_path__ + "static/media/newUnbilledAmountIcon.4bb44cf590f44230e00703156b574b56.svg";
export { ForwardRef as ReactComponent };